import { useEffect } from "react"
import { ssoApi } from "../../api/lensService";

export const CallBack = () => {
    // Handle SSO callback with ?id= query parameter
    const handleSSOCallback = async (id) => {
        if (!id) {
            document.location.href = "/";
            return;
        }
        const result = await ssoApi.get(`api/auth/getToken?id=${id}`);
        localStorage.setItem('TOKEN', result?.data?.data?.accessToken);
        localStorage.setItem("user", JSON.stringify({ ...result?.data?.data, remember: result?.data?.data?.remember }));
        document.location.href = "/dashboard";
    }

    // Handle Cognito callback with #access_token= hash fragment
    const handleCognitoCallback = (hashParams) => {
        const accessToken = hashParams.get('access_token');
        const idToken = hashParams.get('id_token');

        if (!accessToken) {
            console.error('No access token found in Cognito callback');
            document.location.href = "/";
            return;
        }

        // Parse the JWT to extract user info from id_token
        let userData = {};
        if (idToken) {
            try {
                const payload = JSON.parse(atob(idToken.split('.')[1]));

                // Check both cognito:groups (array) and custom:groups (comma-separated string)
                const cognitoGroups = payload['cognito:groups'] || [];
                const customGroups = payload['custom:groups'] || '';

                // Combine both sources into a single array
                const userGroupList = [
                    ...(Array.isArray(cognitoGroups) ? cognitoGroups : []),
                    ...customGroups.split(',').map(g => g.trim()).filter(g => g)
                ];

                // Map Cognito groups to roles and access type
                const adminGroups = ['APP_VK00_9DD0_TEKVISION_ADMINS', 'Admins'];
                const isAdmin = userGroupList.some(g => adminGroups.includes(g));
                const roles = isAdmin ? ['ROLE_ADMIN'] : ['ROLE_USER'];
                const accessType = isAdmin ? 'read-write' : 'read-only';

                userData = {
                    username: payload['cognito:username'] || payload.email || payload.sub,
                    email: payload.email,
                    groups: userGroupList.join(','),
                    sub: payload.sub,
                    roles: roles,
                    accessType: accessType
                };
            } catch (e) {
                console.error('Failed to parse id_token', e);
            }
        }

        localStorage.setItem('TOKEN', accessToken);
        localStorage.setItem("user", JSON.stringify({ ...userData, remember: false }));
        document.location.href = "/dashboard";
    }

    useEffect(() => {
        const hash = window.location.hash;
        const search = window.location.search;

        // Check for Cognito implicit grant (hash fragment with access_token)
        if (hash && hash.includes('access_token')) {
            const hashParams = new URLSearchParams(hash.substring(1));
            handleCognitoCallback(hashParams);
        }
        // Check for SSO callback (query parameter with id)
        else if (search && search.includes('id=')) {
            const id = search.replace('?id=', '');
            handleSSOCallback(id);
        }
        // No valid callback params
        else {
            console.error('No valid callback parameters found');
            document.location.href = "/";
        }
    }, [])

    return null;
}